import React from "react"

export const FilterButton = () => {
  return(
    <span className='indentation'>
      <a className='multi_filter btn-filter circle-icon teal inline-box' href="#">
        <i className='fa fa-filter'></i>
      </a>
    </span>
  )
}
